import isObject from 'lodash/isObject'

import { isNotEmpty } from '@helpers'

export const renderObjectEmbeddedCell = (
  code: string,
  // objectValue: string,
  srcObj: Record<string, any>
) => {
  // const linkedObject = srcObj[`${code}_enriched`] || {}
  // const valueByObjectValue = linkedObject[objectValue]

  // return valueByObjectValue || ''

  const result = isNotEmpty(srcObj[code]) ? srcObj[code] : ''

  if (isObject(result)) {
    if ('label' in result) return result.label

    if (Array.isArray(result)) return result.map(item => item.label || '').join(', ')

    return Object.values(result).join(', ')
  }

  return String(result)
}
